export default __webpack_public_path__ + "static/media/icon_pst_tier_try.3ceb16cf.svg";